module.exports = __webpack_public_path__ + "img/chambre 4.e48968fb.jpeg";